import { environment } from '../../../../../environments/environment';
import { AppConstants } from '../services/api/app-constants';

export const findUserQueries = {
  query: `
  query userfilter( $user_name: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listRncUsers} (filter:{
      user_name : { eq : $user_name}
    })
    {
      items {
        id
        user_name
        password
        user_type
        email_address
        name
        employee_phone

      }
      nextToken
    }
  }
  `,
};

// query getVehicleMaster ($nextToken: String, $limit: Int){
//   ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}(nextToken: $nextToken, limit: $limit)

export const filterByUserType = {
  query: `
  query ByUserType($nextToken: String, $limit: Int, $user_type: Int){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listRncUsers} (nextToken: $nextToken, limit: $limit,filter:{
      user_type : { eq : $user_type}
    })
    {
      items {
        id
        user_name
        user_type
        name
      }
      nextToken
    }
  }
  `,
};

/*****************************************************************************
 * CAP ASSIST - USER ACCESS CONTROL
 ****************************************************************************/
export const cpUserAccessControlQueries = {
  query: `
  query cpUserAccessControl{
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpRnUser}
    {
      items{
        id
        user_name
        name
        email
        phone
        assign_mode
        status
        ex_data
        created_date
        updated_date
        }
      nextToken
    }
  }
  `,
};

export const checkUserAccessControlQueries = {
  query: `
  query checkUserAccessControl( $user_name: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpRnUser} (filter:{
      user_name : { eq : $user_name}
    })
    {
      items {
        id
        user_name
        name
        email
        phone
        assign_mode
        status
        ex_data
        created_date
        updated_date
        }
      nextToken
    }
  }
  `,
};

export const createUACQueries = {
  mutation: `
    mutation createUAC(
      $user_name: String
      $name: String
      $email: String
      $phone: String
      $assign_mode: [String]
      $status: String
      $ex_data: String
      $created_date: String
      $updated_date: String
    ) {
      ${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpRnUser}(input: {
      user_name: $user_name
      name: $name
      email: $email
      phone: $phone
      assign_mode: $assign_mode
      status: $status
      ex_data: $ex_data
      created_date: $created_date
      updated_date: $updated_date
      }) {
        user_name
        name
        email
        phone
        assign_mode
        status
        ex_data
        created_date
        updated_date

      }
    }
  `,
};

export const updateUACQueries = {
  mutation: `
    mutation updateUAC(
      $id: ID!,
      $user_name: String
      $name: String
      $email: String
      $phone: String
      $assign_mode: [String]
      $status: String
      $ex_data: String
      $updated_date: String
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.UpdateCpRnUser}(input: {
      id: $id,
      user_name: $user_name
      name: $name
      email: $email
      phone: $phone
      assign_mode: $assign_mode
      status: $status
      ex_data: $ex_data
      updated_date: $updated_date
      }) {
        id
        user_name
        name
        email
        phone
        assign_mode
        status
        ex_data
        created_date
        updated_date

      }
    }
  `,
};

// emergency_phone
//         employee_phone
//         home_address{
//           lat
//           long
//           elat
//           elong
//           address
//         }
//         name

//         profile_image

//         user_type
//         sos_enabled
//         agency_type
//         is_manager
//         is_temporary_password
//         email_address
//         reporting_manager
//         is_mail_sent
//         is_active
//         zId
//         employee_department
//         company_designation
//         employee_type
//         cost_centre_code
//         group_as_per_cost_centre
//         division_as_per_cost_centre
//         sez_dta
//         plant_code
//         gstin_number
//         office_address{
//           lat
//           long
//           elat
//           elong
//           address
//         }
